// Google Analytics 4 utility functions with GDPR consent management
import ReactGA from 'react-ga4';

const COOKIE_CONSENT_KEY = 'sk_jenbach_cookie_consent';

let isInitialized = false;

// Check if analytics consent was given
const hasAnalyticsConsent = () => {
  try {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (stored) {
      const consent = JSON.parse(stored);
      return consent?.analytics === true;
    }
  } catch (e) {
    console.error('Error reading cookie consent:', e);
  }
  return false;
};

export const initGA = (measurementId) => {
  if (!measurementId || isInitialized) return;
  
  // Only initialize if user has given consent
  if (!hasAnalyticsConsent()) {
    console.log('Google Analytics blocked - no user consent');
    return;
  }
  
  try {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        anonymizeIp: true // GDPR compliant - anonymize IP addresses
      }
    });
    isInitialized = true;
    console.log('Google Analytics initialized with consent');
  } catch (error) {
    console.error('Error initializing Google Analytics:', error);
  }
};

export const logPageView = (path) => {
  if (!isInitialized || !hasAnalyticsConsent()) return;
  
  try {
    ReactGA.send({ hitType: 'pageview', page: path });
  } catch (error) {
    console.error('Error logging page view:', error);
  }
};

export const logEvent = (category, action, label = null, value = null) => {
  if (!isInitialized || !hasAnalyticsConsent()) return;
  
  try {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  } catch (error) {
    console.error('Error logging event:', error);
  }
};

// Function to check consent status
export const isGAEnabled = () => {
  return isInitialized && hasAnalyticsConsent();
};
